<template>
    <select @change="setSelectedStore" class="form-control" v-model="selected_store">
        <option v-for="(store, index) in stores" :key="index" :value="store.id">{{ store.title || store.name }}</option>
    </select>
</template>

<script>
    import api from '@/api'

    export default {
        data() {
            return {
                stores: {},
                selected_store: null
            }
        },
        async mounted () {
            await this.getStores();
            this.setSelectedStore();
        },
        methods: {
            async getStores () {
                const {data} = await api.index('/getStores')
                this.stores = data.stores.all_stores;
                let keys = Object.keys(this.stores);
                this.selected_store = this.stores[keys[0]].id
                this.$parent.store_names = data.stores.all_stores;
            },
            setSelectedStore() {
                this.$parent.selected_store = this.selected_store;
            }
        }
    }
</script>
